// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"12816512","453":"7714b011","588":"3a3d1455","658":"f7de736d","985":"8e82c647"}[chunkId] + ".chunk.js";
};